<app-dialog-header [title]="dialogTitle" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24 pb-0" fxLayout="column" fxLayoutAlign="start">
    <p class="basic-text mb-24 mt-8" *ngIf="label">{{ label }}</p>
    <mat-form-field>
        <input matInput noWhitespace [placeholder]="placeholder | translate" [formControl]="nameCtrl" (keydown.enter)="saveDialog()" />
        <!-- we're hiding FormControl 'required' error and showing API errors -->
        <mat-error *ngIf="nameCtrl.errors && !nameCtrl.hasError('required')">{{ 'ERROR.RESPONSE.' + nameCtrl.errors['message'] | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field class="mt-16">
        <input
            matInput
            type="number"
            min="1"
            placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.TARGET_CERTIFICATION_COUNT' | translate }}"
            [formControl]="targetCtrl"
            (keydown.enter)="saveDialog()"
        />
    </mat-form-field>
    <mat-slide-toggle class="mt-8" [formControl]="toggleCtrl">
        <h3 class="ml-16">{{ toggleLabel | translate }}</h3>
    </mat-slide-toggle>
</div>
<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <div class="button-container">
        <div class="spinner-container" *ngIf="showSpinner">
            <mat-spinner diameter="24"></mat-spinner>
        </div>

        <app-flat-button
            [label]="buttonLabel"
            (onClick)="saveDialog()"
            [disabled]="!nameCtrl.valid || showSpinner || (disableUntilChanged && !nameCtrl.dirty && !toggleCtrl.dirty && !targetCtrl.dirty)"
        ></app-flat-button>
    </div>
</div>
